<template>
  <v-row class="pa-3 pt-4">
    <v-col cols="12">
      <v-row v-if="impersonationAlert">
        <v-col cols="12">
          <v-alert
            type="warning"
            v-model="impersonationAlert"
            closable
            density="compact"
            variant="outlined"
          >
            You're currently impersonating: {{ impersonatedAgent }}
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <router-view name="default" lazy></router-view>
        <router-view name="view" lazy></router-view>
      </v-row>
      <v-row>
        <impersonation-dialog
          :dialog.sync="impersonationDialog"
          :dialogType="impersonateDialogType"
          :brokerageName.sync="impersonatedAgent"
          @cancel="impersonateCancel"
          @disable="disableImpersonation"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { defineAsyncComponent } from "vue";

export default {
  props: {},
  components: {
    ImpersonationDialog: defineAsyncComponent(
      () => import("@/components/console/dialog/ImpersonationDialog.vue"),
    ),
  },
  data() {
    return {
      impersonationAlert: false,
      impersonationDialog: false,
      impersonateDialogType: "disableImpersonate",
    };
  },
  methods: {
    impersonateCancel() {
      this.impersonationAlert = true;
      this.impersonationDialog = false;
    },
    disableImpersonation() {
      this.$store.dispatch("auth/clearImpersonate").then(() => {
        this.impersonationDialog = false;
        this.$router.push("/console/lenders");
      });
    },
  },
  computed: {
    ...mapGetters("auth", ["impLoanOffice", "impUser"]),
    impersonatedAgent() {
      if (this.impLoanOffice === null) {
        return "";
      }

      return this.impLoanOffice.name;
    },
  },
  watch: {
    impersonationAlert(n) {
      if (n === false) {
        this.impersonationDialog = true;
      }
    },
  },
  mounted() {
    this.impersonationAlert = false;
    if (this.impLoanOffice) {
      this.impersonationAlert = true;
    }
  },
};
</script>
